// <s-product-motion> — product page motion shell. Marks the one-time intro as done so
// variant partial re-renders don't replay it, and tilts [data-pdp-tilt] toward the pointer
// on hover-capable devices. Does nothing beyond marking the intro when motion is reduced.
class SProductMotion extends HTMLElement {
  #ac = null;
  #timer = 0;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.#timer = window.setTimeout(() => this.setAttribute("data-intro-done", ""), reduce ? 0 : 1800);
    if (reduce || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    const target = this.querySelector("[data-pdp-tilt]");
    if (!target) return;
    const { signal } = this.#ac;

    target.addEventListener("pointermove", (event) => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        const rect = target.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        target.style.setProperty("--pdp-tilt-y", `${(x * 6).toFixed(2)}deg`);
        target.style.setProperty("--pdp-tilt-x", `${(-y * 6).toFixed(2)}deg`);
      });
    }, { signal });

    target.addEventListener("pointerleave", () => {
      cancelAnimationFrame(this.#frame);
      target.style.setProperty("--pdp-tilt-y", "0deg");
      target.style.setProperty("--pdp-tilt-x", "0deg");
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
    cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get("s-product-motion")) customElements.define("s-product-motion", SProductMotion);
